<template>
  <q-badge
    v-if="isEnabled"
    v-bind="$attrs"
    :color="color"
    :floating="floating"
    :rounded="rounded"
    :label="label"
    :class="badgeClass"
    :style="badgeStyle"
    :title="title"
    @click="handleClick"
  >
    <slot/>
  </q-badge>
  <CuiBadge
    v-else
    v-bind="$attrs"
    :label="label"
    :class="badgeClass"
    :style="badgeStyle"
    :title="title"
    @click="handleClick"
  >
    <slot/>
  </CuiBadge>
</template>

<script>
import { useFeatureFlags } from "@/composables/useFeatureFlags";

export default {
  name: "dtpBadge",
  inheritAttrs: false,
  emits: ["click"],
  props: {
    color: {
      type: String,
      default: undefined
    },
    floating: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, Number],
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    }
  },
  setup() {
    const { isEnabled: checkEnabled } = useFeatureFlags();
    const isEnabled = checkEnabled("dtpBadge");
    return { isEnabled };
  },
  computed: {
    badgeClass() {
      return this.$attrs.class;
    },
    badgeStyle() {
      return this.$attrs.style;
    }
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>
